// Standard library imports
import React, { useState, useEffect } from 'react';

// Internal module imports
import { timeOnly } from '../../../utils/dateHelper';
import { useLoader } from '../../../hooks';

// Css imports
import classes from '../../DemandResponse/DemandResponse.module.css';
import { EVCService } from '../../../services/EVCService';
import TabsComponent from '../../../components/Tabs/Tabs';
import EChart from '../../../components/Echarts/Echarts';
import { usToEuCurrencyFormat } from '../../../utils/currencyHelper';

const TransactionInfoModal = ({ data, setOpen, updateQueryParams, queryParamsData }) => {
    const [startLoader, stopLoader] = useLoader();
    const [graphData, setGraphData] = useState([]);
    const [consumptionData, setConsumptionData] = useState([]);
    const [socData, setSocData] = useState([]);
    const [selectedIndex] = useState(queryParamsData.subTab ? queryParamsData.subTab : 0);

    useEffect(() => {
        fetchTransactionInfo();
    }, []);

    const fetchTransactionInfo = () => {
        if (data._id) {
            EVCService.FetchTransactionInfo(data._id, startLoader, handleTransactionSuccess, handleError, stopLoader);
        }
    };

    const handleTransactionSuccess = ({ data }) => {
        setGraphData(data.data.powerData);
        setConsumptionData(data.data.consumptionData || [{ data: [] }]);
        setSocData(data.data.SocData || [{ data: [] }]);
    };

    const handleError = (err) => {
        console.log(err);
    };

    let tabs = [
        {
            name: 'Power (kW)',
            component: (
                <div>
                    <EChart series={graphData} type="line" xFormatter={timeOnly} yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))} yTooltipSuffix={['kW']} />
                </div>
            ),
        },
        {
            name: 'Consumption (kWh)',
            component: (
                <div>
                    <EChart
                        series={consumptionData}
                        type="line"
                        lineType="area"
                        xFormatter={timeOnly}
                        yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))}
                        yTooltipSuffix={['kWh']}
                    />
                </div>
            ),
        },
        {
            name: 'SoC (kWh)',
            component: (
                <div>
                    <EChart series={socData} type="line" xFormatter={timeOnly} yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))} yTooltipSuffix={['kWh']} />
                </div>
            ),
        },
    ];

    return (
        <div style={{ width: '50vw', maxHeight: '90vh' }}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    updateQueryParams('subTab', index);
                }}
            />
            <div className={classes.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default TransactionInfoModal;
